import { AaaRatingCategory} from 'src/app/api/models';

export const AAARatings: AaaRatingCategory[] = [
    AaaRatingCategory.Aaa,
    AaaRatingCategory.Aa,
    AaaRatingCategory.A,
    AaaRatingCategory.An,
    AaaRatingCategory.B,
    AaaRatingCategory.C,
    AaaRatingCategory.NotRated,
];
